
// import brand_img_1 from "../../assets/img/partner_1.svg"
// import brand_img_2 from "../../assets/img/partner_2.svg"
// import brand_img_3 from "../../assets/img/partner_3.svg"
// import brand_img_4 from "../../assets/img/partner_4.svg"
// import brand_img_5 from "../../assets/img/partner_5.svg"
// import brand_img_6 from "../../assets/img/partner_6.svg"
// import brand_img_7 from "../../assets/img/partner_7.svg"
// import brand_img_8 from "../../assets/img/partner_8.svg"
// import brand_img_9 from "../../assets/img/partner_11.svg"

// import brand_thumb_1 from "../..assets/img/partner_9.svg"
// import brand_thumb_2 from "../..assets/img/partner_10.svg"
// import brand_thumb_3 from "../..assets/img/partner_11.svg"
// import brand_thumb_4 from "../..assets/img/partner_12.svg"
// import brand_thumb_5 from "../..assets/img/partner_13.svg"
// import brand_thumb_6 from "../..assets/img/partner_14.svg"
// import brand_thumb_7 from "../..assets/img/partner_15.svg"
// import brand_thumb_8 from "../..assets/img/partner_1.svg"
// import brand_thumb_9 from "../../assets/img/partner_3.svg"

// logo image import 
// import Chaitanya from "../../assets/img/ClientLogo/Chaitanya.svg";
// import Chandrayu from "../../assets/img/ClientLogo/Chandrayu.svg";
// import daksh from "../../assets/img/ClientLogo/daksh.svg";
// import ENT from "../../assets/img/ClientLogo/ENT.svg";
// import IVF from "../../assets/img/ClientLogo/IVF.svg";
// import JBPHos from "../../assets/img/ClientLogo/JabalpurHospital.svg";
// import JanJyoti from "../../assets/img/ClientLogo/JanJyoti.svg";
// import Lari from "../../assets/img/ClientLogo/Lari.svg";
// import IVFMahakoshal from "../../assets/img/ClientLogo/Mahakoshal.svg";
// import Milton from "../../assets/img/ClientLogo/Milton.svg";
// import NiceHome from "../../assets/img/ClientLogo/NiceHome.svg";
// import OneRealty from "../../assets/img/ClientLogo/OneRealty.svg";
// import RamAc from "../../assets/img/ClientLogo/RamAca.svg";
// import RohiniDent from "../../assets/img/ClientLogo/RohiniDent.svg";
// import SDH from "../../assets/img/ClientLogo/SDH.svg";
import { Link } from "react-router-dom";
// import Chaitanya from "../../assets/img/ClientLogo/Chaitanya.jpeg";
import Chaitanya from "../../assets/img/ClientLogo/Chaitanya_imresizer.png";
import Chandrayu from "../../assets/img/ClientLogo/chandrayunew.png";
import daksh from "../../assets/img/ClientLogo/daksh.jpeg";
// import ENT from "../../assets/img/ClientLogo/ENT.jpeg";
import ENT from "../../assets/img/ClientLogo/ENT_imresizer.png";
// import IVF from "../../assets/img/ClientLogo/IVF.jpeg";
import IVF from "../../assets/img/ClientLogo/IVF_imresizer.png";
// import JBPHos from "../../assets/img/ClientLogo/JabalpurHospital.jpeg";
import JBPHos from "../../assets/img/ClientLogo/JabalpurHospital_imresizer.png";
// import JanJyoti from "../../assets/img/ClientLogo/JanJyoti.jpeg";
import JanJyoti from "../../assets/img/ClientLogo/JanJyoti_imresizer.png";
import Lari from "../../assets/img/ClientLogo/Lari.jpeg";
import IVFMahakoshal from "../../assets/img/ClientLogo/Mahakoshal.jpeg";
import Milton from "../../assets/img/ClientLogo/Milton.jpeg";
// import NiceHome from "../../assets/img/ClientLogo/NiceHome.jpeg";
import NiceHome from "../../assets/img/ClientLogo/NiceHome_imresizer.png";
// import OneRealty from "../../assets/img/ClientLogo/OneRealty.jpeg";
import OneRealty from "../../assets/img/ClientLogo/OneRealty_imresizer.png";
import RamAc from "../../assets/img/ClientLogo/RamAca.jpeg";
import RohiniDent from "../../assets/img/ClientLogo/RohiniDent.jpeg";
import SDH from "../../assets/img/ClientLogo/SDH.jpeg";



import aa from "../../assets/img/ClientLogo/aa.webp";
import amh from "../../assets/img/ClientLogo/amh.webp";
import anil from "../../assets/img/ClientLogo/anil.webp";
import bala from "../../assets/img/ClientLogo/bala.webp";
// import chandra from "../../assets/img/ClientLogo/chandra.webp";
import chandra from "../../assets/img/ClientLogo/chandra_imresizer.png";
import anishque from "../../assets/img/ClientLogo/anishque.webp";
import cios from "../../assets/img/ClientLogo/cios.webp";
// import fignter from "../../assets/img/ClientLogo/fignter.webp";
import fignter from "../../assets/img/ClientLogo/fignter_imresizer.png";
import hcabaj from "../../assets/img/ClientLogo/hcabaj.webp";
import nextgen from "../../assets/img/ClientLogo/nextgen.webp";
import sachin from "../../assets/img/ClientLogo/spark.webp";
import studyverse from "../../assets/img/ClientLogo/studyverse.webp";
import vinasia from "../../assets/img/ClientLogo/vinasia.webp";
import den from "../../assets/img/ClientLogo/den.webp";
import flip from "../../assets/img/ClientLogo/flip.webp";
import incredible from "../../assets/img/ClientLogo/incredible.webp";
import petayu from "../../assets/img/ClientLogo/petayu.webp";
import princeviraj from "../../assets/img/ClientLogo/princeviraj.webp";
import se from "../../assets/img/ClientLogo/se.webp";
import shadivivah from "../../assets/img/ClientLogo/shadivivah.webp";
import subhmed from "../../assets/img/ClientLogo/subhmed.webp";
import Times from "../../assets/img/ClientLogo/Times.webp";
// import fornear from "../../assets/img/ClientLogo/fornear.webp";
import fornear from "../../assets/img/ClientLogo/fornear_imresizer.png";
import sanjulogo from "../../assets/img/ClientLogo/sanjulogo.webp";
import gala from "../../assets/img/ClientLogo/gala.webp";
import jsss from "../../assets/img/ClientLogo/jsss.webp";
import woj from "../../assets/img/ClientLogo/woj150.webp";
import swa from "../../assets/img/ClientLogo/swa.webp";
// import img10 from "../../assets/img/ClientLogo/10.webp";
// import img11 from "../../assets/img/ClientLogo/11.webp";
// import img12 from "../../assets/img/ClientLogo/12.webp";
// import img13 from "../../assets/img/ClientLogo/13.webp";
// import img15 from "../../assets/img/ClientLogo/15.webp";
// import img16 from "../../assets/img/ClientLogo/16.webp";
// import img17 from "../../assets/img/ClientLogo/17.webp";
// import img18 from "../../assets/img/ClientLogo/18.webp";
// import img19 from "../../assets/img/ClientLogo/19.webp";
// import img20 from "../../assets/img/ClientLogo/20.webp";
// import img21 from "../../assets/img/ClientLogo/21.webp";
// import img23 from "../../assets/img/ClientLogo/23.webp";
// import img24 from "../../assets/img/ClientLogo/24.webp";
import img10 from "../../assets/img/ClientLogo/10_imresizer.png";
import img11 from "../../assets/img/ClientLogo/11_imresizer.png";
import img12 from "../../assets/img/ClientLogo/12_imresizer.png";
import img13 from "../../assets/img/ClientLogo/13_imresizer.png";
import img15 from "../../assets/img/ClientLogo/15_imresizer.png";
import img16 from "../../assets/img/ClientLogo/16_imresizer.png";
import img17 from "../../assets/img/ClientLogo/17_imresizer.png";
import img18 from "../../assets/img/ClientLogo/18_imresizer.png";
import img19 from "../../assets/img/ClientLogo/19_imresizer.png";
import img20 from "../../assets/img/ClientLogo/20_imresizer.png";
import img21 from "../../assets/img/ClientLogo/21_imresizer.png";
import img23 from "../../assets/img/ClientLogo/23_imresizer.png";
import img24 from "../../assets/img/ClientLogo/24_imresizer.png";
const brand_data = [
  Chaitanya,
  Chandrayu,
  daksh,
  ENT,
  IVF,
  JBPHos,
  JanJyoti,
  Lari,
  IVFMahakoshal,
  Milton,
  NiceHome,
  OneRealty,
  RamAc,
  RohiniDent,
  SDH,
  img10,
  img11,
  img12,
  img13,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img23,
  img24
]




const brand_thumb_data = [
  aa,
  amh,
  anil,
  bala,
  chandra,
  anishque,
  cios,
  fignter,
  hcabaj,
  nextgen,
  sachin,
  studyverse,
  vinasia,
  den,
  flip,
  incredible,
  petayu,
  princeviraj,
  se,
  shadivivah,
  subhmed,
  Times,
  fornear,
  sanjulogo,
  gala,
  jsss,
  woj,
  swa

]


const cityButtonData = [
  { city: 'Delhi', route: '/best-seo-services-in-delhi' },
  { city: 'Mumbai', route: '/best-seo-services-in-mumbai' },
  { city: 'Pune', route: '/best-seo-services-in-pune' },
  { city: 'Bangalore', route: '/best-seo-services-in-bangalore' },
  { city: 'Noida', route: '/best-seo-services-in-noida' },
  { city: 'Indore', route: '/best-seo-services-indore' },
]

const OurClient = ({ style_2 }) => {
  return (
    <>

      {style_2 ?
        <>
          {/* <div className="cs_height_150 cs_height_lg_60"></div> */}
          {/* <p className="text-center cs_font_18 cs_normal">
            100+ Clients & Partners Who Trust DOAGuru
          </p> */}

          <div className="cs_section_heading cs_style_1 cs_type_2 adding">
            <div className="cs_section_heading_text">
              <div className="cs_section_subtitle anim_div_ShowZoom">
                Our Client's
              </div>
              <h2 className="cs_section_title anim_heading_title">
                100+ Clients & Partners Who Trust DOAGuru
              </h2>
            </div>
          </div>
          <div className="cs_height_100 cs_height_lg_60"></div>
        </>
        :
        <div className="cs_height_140 cs_height_lg_70"></div>
      }
      <div className="cs_moving_section_wrap cs_bold cs_moving_section_hover_push">
        <div className="cs_moving_section_in">
          <div className="cs_moving_section cs_animation_speed_100">
            <div className="cs_partner_logo_wrap">
              {brand_data.map((item, i) =>
                <div key={i} className="cs_partner_logo">
                  <img src={item} alt="image-here" />
                </div>
              )}
            </div>
          </div>
          <div className="cs_moving_section cs_animation_speed_100">
            <div className="cs_partner_logo_wrap">
              {brand_data.map((item, i) =>
                <div key={i} className="cs_partner_logo">
                  <img src={item} alt="image-here" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="cs_height_45 cs_height_lg_45"></div>
      <div className="cs_moving_section_wrap cs_bold cs_moving_section_hover_push">
        <div className="cs_moving_section_in">
          <div className="cs_moving_section cs_animation_speed_130">
            <div className="cs_partner_logo_wrap">
              {brand_thumb_data.map((item, i) =>
                <div key={i} className="cs_partner_logo">
                  <img src={item} alt="image-here" />
                </div>
              )}
            </div>
          </div>
          <div className="cs_moving_section cs_animation_speed_130">
            <div className="cs_partner_logo_wrap">
              {brand_thumb_data.map((item, i) =>
                <div key={i} className="cs_partner_logo">
                  <img src={item} alt="image-here" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* {style_2 ? null :
        <div className="cs_height_140 cs_height_lg_70"></div>
      } */}
      <div className="cs_section_heading cs_style_1 cs_type_2 adding">
        <div className="cs_section_heading_text">
          <div className="cs_section_subtitle anim_div_ShowZoom">
            Cities We Serve
          </div>
          <h3 className="cs_section_title anim_heading_title">
            SEO Services in Top Indian Cities
          </h3>
        </div>
      </div>
      {/* Scoped styles to remove default circular ::before and style city buttons */}
      <style>{`
        .cs_city_button_row .cs_btn.cs_style_1::before {
          display: none !important;
        }
        .cs_city_button_row .cs_btn.cs_style_1 {
          background: transparent !important;
          color: #111 !important;
          border: 1px solid rgba(0,0,0,0.08);
          border-radius: 28px !important;
          padding: 8px 16px !important;
          font-weight: 600;
          letter-spacing: 0.02em;
        }
        .cs_city_button_row .cs_btn.cs_style_1:hover {
          color: #fe7604 !important;
          border-color: #fe7604 !important;
          transform: translateY(-2px);
        }
      `}</style>
      <div
        className="cs_city_button_row"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '12px',
          marginTop: '16px',
          padding: '0 12px',
        }}
      >
        {cityButtonData.map((item) => (
          <Link
            key={item.city}
            to={item.route}
            className="cs_btn cs_style_1 cs_color_1 cs_type_btn"
            style={{
              minWidth: '120px',
              textAlign: 'center',
              textTransform: 'uppercase',
              padding: '8px 14px',
              background: 'transparent',
              color: '#111111',
              borderRadius: '24px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: 'none',
              textDecoration: 'none',
              transition: 'color 0.18s ease, transform 0.15s ease, border-color 0.18s ease',
              border: '1px solid rgba(0,0,0,0.06)',
              fontWeight: 600,
              letterSpacing: '0.02em'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#fe7604';
              e.currentTarget.style.borderColor = '#fe7604';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#111111';
              e.currentTarget.style.borderColor = 'rgba(0,0,0,0.06)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            {item.city}
          </Link>
        ))}
      </div>
      <div className="cs_height_140 cs_height_lg_70"></div>
    </>
  );
};

export default OurClient;
